import React, { Fragment } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import withLoading from "./hocs/withLoading";
import OnboardDone from "./components/OnboardDone/index";
import {
  OnboardContainer,
  BasicInfoName,
  BasicInfoAddress,
  CvUpload as CvUploadContainer,
  WorkHistory,
  EditWorkHistory,
  WorkType,
  PersonalDeclaration,
  Profile,
  ProfileEdit,
  InternalServerError,
  ProfileCompletionCard,
  ProfileRegistrationSection,
  ProfileLegalComplianceSection,
  CandidateJobCard,
  JobRegistrationSection,
  JobLegalComplianceSection,
  JobFormBuilderSection,
} from "./containers";

import CvUpload from "./components/CvUpload";
import BasicInfoUpdate from "./containers/BasicInfoUpdate";
import Payroll from "./containers/Payroll/Payroll";
import Timesheets from "./components/Timesheets/index";
import Shifts from "./components/Shifts/index";
import Timesheet from "./components/Timesheet/index";
import Bookings from "./components/Bookings";
import BookingDetails from "./components/BookingDetails";
import Payslips from "./components/Payslips/index";
import Holiday from "./components/Holiday/index";
import ReflexAllenOnboarding from "./containers/ReflexAllenOnboarding";
import GreatBearOnboardingContainer from "./containers/GreatBearOnboarding";
import RegulationsForm from "./components/OnlineForms/RegulationsForm";
import NightWorkersQuestionnaire from "./components/OnlineForms/NightWorkersQuestionnaire";
import CommunicationPreferences from "./components/CommunicationPreferences";
import ProfileCommunicationPreferences from "./components/ProfileCommunicationPreferences";
import InductionProgramme from "./components/ReflexAllenOnboarding/InductionProgramme";
import ScrollToTop from "./common/Scroll/ScrollToTop";
import HideBodyOverflowY from "./common/Scroll/HideBodyOverflowY";
import OnboardingTracker from "./components/OnboardingTracker";
import Onboarding from "./components/RoyalMail/Onboarding";
import SwissportOnboarding from "./components/Swissport/SwissportOnboarding";
import FiveYearHistory from "./components/Swissport/FiveYearHistory";
import EmployeeHealthQuestionnaire from "./components/Swissport/EmployeeHealthQuestionnaire";
import PersonalInformationForm from "./components/Swissport/PersonalInformationForm";
import InformationReleaseForm from "./components/Swissport/InformationReleaseForm";
import PecanOnboarding from "./components/Pecan/PecanOnboarding";
import HealthQuestionnaireForm from "./components/Pecan/HealthQuestionnaireForm";
import PecanAssessment from "./components/Pecan/PecanAssessment";
import NextOfKinForm from "./components/Pecan/NextOfKinForm";
import KingspanOnboarding from "./containers/KingspanOnboarding";
import KingspanLiteracyAssessment from "./components/Kingspan/KingspanLiteracyAssessment";
import CarltonForestOnboarding from "./containers/CarltonForestOnboarding";
import ThanetCouncilOnboarding from "./components/ThanetCouncil/ThanetCouncilOnboarding";
import BenefitsDeclarationForm from "./components/ThanetCouncil/BenefitsDeclarationForm";
import DriverDeclarationForm from "./components/ThanetCouncil/DriverDeclarationForm";
import InductionSignoffForm from "./components/ThanetCouncil/InductionSignoffForm";
import QuestionsStage1Form from "./components/ThanetCouncil/QuestionsStage1Form";
import ShiftInductionForm from "./components/ThanetCouncil/ShiftInductionForm";
import DVLACheckAndSignatureForm from "./components/ThanetCouncil/DVLACheckAndSignatureForm";
import CpiOnboarding from "./containers/CpiOnboarding";
import InductionChecklist from "./components/CarltonForest/InductionChecklist";
import TrafficForm from "./components/RoyalMail/TrafficForm";
import SecurityForm from "./components/RoyalMail/SecurityForm";
import AdditionalSecurityForm from "./components/RoyalMail/AdditionalSecurityForm";
import PreviousAddressForm from "./components/RoyalMail/PreviousAddressForm";
import FiveYearForm from "./components/RoyalMail/FiveYearForm";
import DeclarationForm from "./components/RoyalMail/DeclarationForm";
import InductionConfirmation from "./components/RoyalMail/InductionConfirmation";
import AccountSettings from "./components/AccountSettings";
import Documentation from "./containers/Documentation/Documentation";
import { isMobile } from "./helpers";
import DrivingOnboarding from "./components/Driving/Onboarding";
import SkillsAndQualificationsForm from "./components/Driving/SkillsAndQualificationsForm";
import NonHGVAssessment from "./components/Driving/DrivingAssessments/NonHGVAssessment";
import FeedbackScreen from "./components/Driving/DrivingAssessments/FeedbackScreen";
import LicenceDetailsAndDvlaCheck from "./components/Driving/LicenceDetailsAndDvlaCheck";
import ComplianceAndDriversDeclaration from "./components/Driving/ComplianceAndDriversDeclaration";
import NightWorkerHealthAssessment from "./components/NightWorkerHealthAssessment/NightWorkerHealthAssessment";
import ResourcesFolderList from "./containers/ResourcesFolderList";
import resourceHRGO from "./containers/ResourceFolders/resourceHRGO";
import resourceAssignmentForms from "./containers/ResourceFolders/resourceAssignmentForms";
import resourceLabourExploitationSlavery from "./containers/ResourceFolders/resourceLabourExploitationSlavery";
import resourceTemplates from "./containers/ResourceFolders/resourceTemplates";
import resourceMindEBooklets from "./containers/ResourceFolders/resourceMindEBooklets";
import DriverAssessment from "./components/Driving/DrivingAssessments/DriverAssessment";
import AuthorityForPaymentsAssesment from "./components/AuthorityForPaymentsAssesment/AuthorityForPaymentsAssesment";
import GateOnboarding from "./components/GateGroup/GateOnboarding";
import AviationClientOnboarding from "./components/ABM/AbmOnboarding";
import PersonalInformation from "./components/ABM/PersonalInformation";
import ABMWorkHistory from "./components/ABM/WorkHistory";
import ABMConsent from "./components/ABM/Consent";
import Declarations from "./components/ABM/Declarations";
import Application from "./components/GateGroup/Application";
import YearWorkHistory from "./components/GateGroup/5YearWorkHistory";
import Declaration from "./components/GateGroup/Declaration";
import ReferenceEducation from "./components/GateGroup/ReferenceEducation";
import UploadContainer from "./components/Driving/UploadContainer";
import PusterlaOnboarding from "./components/Pusterla/PusterlaOnboarding";
import PusterlaAssessment from "./components/Pusterla/PusterlaAssessment";
import AssessmentFeedback from "./components/Pusterla/AssessmentFeedback";
import RegattaOnboarding from "./components/Regatta/RegattaOnboarding";
import MedicalQuestionnaire from "./components/Regatta/MedicalQuestionnaire";
import OneWeekReview from "./components/Regatta/OneWeekReview";
import SixWeekReview from "./components/Regatta/SixWeekReview";
import TwelveWeekReview from "./components/Regatta/TwelveWeekReview";
import RegattaLiteracyAssessment from "./components/Regatta/RegattaLiteracyAssessment";
import ReturnToWork from "./components/Regatta/ReturnToWork";
import NHSReferences from "./containers/NHSReferences";
import GLAA from "./components/GLAA";
import UmbrellaDeclaration from "./containers/UnbrellaDeclaration";
import MolecularOnboarding from "./components/Molecular/MolecularOnboarding";
import ConsentDrugAlcoholForm from "./components/Molecular/ConsentDrugAlcoholForm";
import LiteracyAssessment from "./components/Molecular/LiteracyAssessment";
import WoodlandGroupOnboarding from "./components/Woodland/WoodlandGroupOnboarding";
import SiteRules from "./components/Woodland/SiteRules";
import Policies from "./components/Woodland/PoliciesAndProcedures";
import HandOuts from "./components/Woodland/HandOuts";
import Machinery from "./components/Woodland/Machinery";
import Training from "./components/Woodland/Training";
import ManualHandling from "./components/Woodland/ManualHandling";
import FireSafety from "./components/Woodland/FireSafety";
import IncidentReporting from "./components/Woodland/IncidentReporting";
import CompleatFoodOnboarding from "./components/CompleatFood/CompleatFoodOnboarding";
import NewStartersDetailsForm from "./components/CompleatFood/NewStarterDetailsForm";
import ConsentForHealthScreeningForm from "./components/CompleatFood/ConsentForHealthScreeningForm";
import PersonalDataConsentForm from "./components/CompleatFood/PersonalDataConsentForm";
import MedicalQuestionnaireForm from "./components/CompleatFood/MedicalQuestionnaireForm";
import GrowUpFarmsOnboarding from "./components/GrowUpFarms/GrowUpFarmsOnboarding";
import HealthAndSafetyQuestionnaire from "./components/GrowUpFarms/HealthAndSafetyQuestionnaire";
import FoodSafetyQuestionnaire from "./components/GrowUpFarms/FoodSafetyQuestionnaire";
import {
  DavinFoodsOnboarding,
  FoodSafetyQuiz,
  FoodAllergensQuiz,
  HealthAndSafetyQuiz,
  ChemicalSafetyQuiz,
  EvacuationQuiz,
  ManualHandlingQuiz,
  InductionChecklistDavinFoods,
} from "./components/DavinFoods/index";
import {
  DnataOnboarding,
  AboutForm,
  EmploymentForm,
  ReferencesForm,
  InformationForm,
  DeclarationDnataForm,
  EqualOpportunitiesForm,
  EmergencyContactForm,
  WishForm,
  HealthQuestionnaire,
  DnataTest,
  NoticeForm,
  TimeRegulationsForm,
} from "./components/Dnata/index";

const CvUploadWithAuthAndLoading = withLoading(CvUploadContainer);
const ProfileLoading = withLoading(ProfileEdit);

const LegalComplianceRoute = ({ path }) => (
  <Route path={path}>
    {({ match }) => {
      const ParentComponentWithLoading = withLoading(ProfileCompletionCard);
      const ChildComponentWithLoading = withLoading(
        ProfileLegalComplianceSection
      );

      return (
        <ParentComponentWithLoading>
          <ChildComponentWithLoading section={match.params.section} />
        </ParentComponentWithLoading>
      );
    }}
  </Route>
);

const Routes = () => (
  <Fragment>
    <OnboardingTracker />
    <ScrollToTop>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/profile" />} />
        <Route
          exact
          path="/communication-preferences"
          component={CommunicationPreferences}
        />
        <Route exact path="/error" component={InternalServerError} />
        <Route path="/onboard">
          <OnboardContainer>
            <Fragment>
              <Route
                path="/onboard/name"
                component={withLoading(() => (
                  <BasicInfoName />
                ))}
              />
              <Route
                path="/onboard/address"
                component={withLoading(() => (
                  <BasicInfoAddress />
                ))}
              />
              <Route
                path="/onboard/cv-upload"
                render={(routeProps) => (
                  <CvUploadWithAuthAndLoading {...routeProps} isOnboarding>
                    {(cvProps) => <CvUpload {...cvProps} isOnboarding />}
                  </CvUploadWithAuthAndLoading>
                )}
              />
              <Route
                path="/onboard/work-history"
                render={(props) => {
                  const WorkHistoryAuth = withLoading(WorkHistory);
                  return <WorkHistoryAuth {...props} isOnboarding />;
                }}
              />
              <Route
                path="/onboard/work-type"
                component={withLoading(WorkType)}
              />
              <Route
                path="/onboard/personal-declaration"
                render={(props) => {
                  const PersonalDeclarationWithAuth =
                    withLoading(PersonalDeclaration);
                  return <PersonalDeclarationWithAuth {...props} />;
                }}
              />
              <Route
                path="/onboard/done"
                component={withLoading(() => (
                  <OnboardDone />
                ))}
              />
            </Fragment>
          </OnboardContainer>
        </Route>
        <Route exact path="/profile" component={withLoading(Profile)} />
        <Route path="/profile/edit/registration/:section(cv|work-history|personal-details|profile-picture|type-of-work|emergency-contact|demographics|personality-test)">
          {({ match }) => {
            const ParentComponentWihLoading = withLoading(
              ProfileCompletionCard
            );
            const ChildComponentWithLoading = withLoading(
              ProfileRegistrationSection
            );
            return (
              <ParentComponentWihLoading>
                <ChildComponentWithLoading section={match.params.section} />
              </ParentComponentWihLoading>
            );
          }}
        </Route>
        <LegalComplianceRoute path="/profile/edit/legal-compliance/rtw/yoti/:section(success|error)" />
        <LegalComplianceRoute path="/profile/edit/legal-compliance/:section(48-hour-opt-out|health-and-disability|contract-for-services|rtw)" />

        <Route path="/profile/edit/job/:id/registration/:section(cv|work-history|personal-details|profile-picture|type-of-work|emergency-contact|demographics|personality-test)">
          {({ match }) => {
            const ParentComponentWihLoading = withLoading(CandidateJobCard);
            const ChildComponentWithLoading = withLoading(
              JobRegistrationSection
            );
            return (
              <ParentComponentWihLoading jobId={match.params.id}>
                <ChildComponentWithLoading
                  jobId={match.params.id}
                  section={match.params.section}
                />
              </ParentComponentWihLoading>
            );
          }}
        </Route>
        <Route path="/profile/edit/job/:id/legal-compliance/rtw/yoti/:section(success|error)">
          {({ match }) => {
            const ParentComponentWihLoading = withLoading(CandidateJobCard);
            const ChildComponentWithLoading = withLoading(
              JobLegalComplianceSection
            );
            return (
              <ParentComponentWihLoading jobId={match.params.id}>
                <ChildComponentWithLoading
                  jobId={match.params.id}
                  section={match.params.section}
                />
              </ParentComponentWihLoading>
            );
          }}
        </Route>
        <Route path="/profile/edit/job/:id/legal-compliance/:section(48-hour-opt-out|health-and-disability|contract-for-services|rtw)">
          {({ match }) => {
            const ParentComponentWihLoading = withLoading(CandidateJobCard);
            const ChildComponentWithLoading = withLoading(
              JobLegalComplianceSection
            );
            return (
              <ParentComponentWihLoading jobId={match.params.id}>
                <ChildComponentWithLoading
                  jobId={match.params.id}
                  section={match.params.section}
                />
              </ParentComponentWihLoading>
            );
          }}
        </Route>
        <Route path="/profile/edit/job/:id/:section(job-requirements|onboarding)/:formId">
          {({ match }) => {
            const ParentComponentWihLoading = withLoading(CandidateJobCard);
            const ChildComponentWithLoading = withLoading(
              JobFormBuilderSection
            );
            return (
              <ParentComponentWihLoading
                jobId={match.params.id}
                formId={match.params.formId}
                section={match.params.section}
              >
                <ChildComponentWithLoading
                  jobId={match.params.id}
                  formId={match.params.formId}
                  section={match.params.section}
                />
              </ParentComponentWihLoading>
            );
          }}
        </Route>
        <Route
          path="/profile/edit/PayrollInformation"
          component={withLoading(Payroll)}
        />
        <Route
          path="/profile/edit/Documentation"
          component={withLoading(isMobile ? Documentation : Profile)}
        />
        <Route
          path="/profile/edit/WorkHistory"
          render={(props) => {
            const WorkHistoryAuth = withLoading(EditWorkHistory);
            return <WorkHistoryAuth {...props} routeWhenDone="/profile" />;
          }}
        />
        <Route
          path="/profile/edit/BasicInfo"
          component={withLoading(BasicInfoUpdate)}
        />
        <Route
          path="/profile/edit/umbrella-declaration"
          component={withLoading(UmbrellaDeclaration)}
        />
        <Route
          path="/profile/edit/nhs-referencing"
          component={withLoading(NHSReferences)}
        />
        <Route
          path="/profile/edit/accountSettings"
          component={withLoading(AccountSettings)}
        />
        <Route
          path="/profile/communicationPreferences"
          component={withLoading(ProfileCommunicationPreferences)}
        />
        <Route
          exact
          path="/profile/edit/resources"
          component={withLoading(ResourcesFolderList)}
        />
        <Route
          exact
          path="/profile/edit/resources/HR_GO"
          component={withLoading(resourceHRGO)}
        />
        <Route
          exact
          path="/profile/edit/resources/Assignment_Forms"
          component={withLoading(resourceAssignmentForms)}
        />

        <Route
          exact
          path="/profile/edit/resources/Labour_Exploitation_and_Modern_Slavery"
          component={withLoading(resourceLabourExploitationSlavery)}
        />

        <Route
          exact
          path="/profile/edit/resources/Templates"
          component={withLoading(resourceTemplates)}
        />

        <Route
          exact
          path="/profile/edit/resources/Mind_E-Booklets"
          component={withLoading(resourceMindEBooklets)}
        />
        <Route
          exact
          path="/profile/edit/stronger-together"
          component={withLoading(GLAA)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding"
          component={withLoading(Onboarding)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/traffic"
          component={withLoading(TrafficForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/security-form"
          component={withLoading(SecurityForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/additional-security-form"
          component={withLoading(AdditionalSecurityForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/additional-security-form"
          component={withLoading(AdditionalSecurityForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/previous-address-form"
          component={withLoading(PreviousAddressForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/5-year-form"
          component={withLoading(FiveYearForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/declaration-form"
          component={withLoading(DeclarationForm)}
        />
        <Route
          exact
          path="/profile/edit/royal-mail-onboarding/induction-form"
          component={withLoading(InductionConfirmation)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding"
          component={withLoading(RegattaOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/medical-questionnaire"
          component={withLoading(MedicalQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/one-week-review"
          component={withLoading(OneWeekReview)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/six-week-review"
          component={withLoading(SixWeekReview)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/twelve-week-review"
          component={withLoading(TwelveWeekReview)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/literacy-assessment"
          component={withLoading(RegattaLiteracyAssessment)}
        />
        <Route
          exact
          path="/profile/edit/regatta-onboarding/return-to-work"
          component={withLoading(ReturnToWork)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding"
          component={withLoading(PusterlaOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding/assessment"
          component={withLoading(PusterlaAssessment)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding/assessment/feedback"
          component={withLoading(AssessmentFeedback)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding"
          component={withLoading(SwissportOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/FiveYearHistory"
          component={withLoading(FiveYearHistory)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/EmployeeHealthQuestionnaire"
          component={withLoading(EmployeeHealthQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/PersonalInformationForm"
          component={withLoading(PersonalInformationForm)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/InformationReleaseForm"
          component={withLoading(InformationReleaseForm)}
        />
        <Route
          exact
          path="/profile/edit/kingspan-onboarding"
          component={withLoading(KingspanOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/kingspan-onboarding/literacy-assessment"
          component={withLoading(KingspanLiteracyAssessment)}
        />

        <Route
          exact
          path="/profile/edit/pecan-onboarding"
          component={withLoading(PecanOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/pecan-onboarding/nextOfKinForm"
          component={withLoading(NextOfKinForm)}
        />
        <Route
          exact
          path="/profile/edit/pecan-onboarding/healthQuestionnaireForm"
          component={withLoading(HealthQuestionnaireForm)}
        />
        <Route
          exact
          path="/profile/edit/pecan-onboarding/assessment"
          component={withLoading(PecanAssessment)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding"
          component={withLoading(DnataOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/about"
          component={withLoading(AboutForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/employment"
          component={withLoading(EmploymentForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/references"
          component={withLoading(ReferencesForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/information"
          component={withLoading(InformationForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/declaration"
          component={withLoading(DeclarationDnataForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/test"
          component={withLoading(DnataTest)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/emergency-contact-form"
          component={withLoading(EmergencyContactForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/equal-opportunities-form"
          component={withLoading(EqualOpportunitiesForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/wish-form"
          component={withLoading(WishForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/notice-form"
          component={withLoading(NoticeForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/time-regulation-form"
          component={withLoading(TimeRegulationsForm)}
        />
        <Route
          exact
          path="/profile/edit/dnata-onboarding/health-questionnaire"
          component={withLoading(HealthQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/ABM-onboarding"
          component={withLoading(AviationClientOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/ABM-onboarding/personal-information"
          component={withLoading(PersonalInformation)}
        />
        <Route
          exact
          path="/profile/edit/ABM-onboarding/work-history"
          component={withLoading(ABMWorkHistory)}
        />
        <Route
          exact
          path="/profile/edit/ABM-onboarding/consent"
          component={withLoading(ABMConsent)}
        />
        <Route
          exact
          path="/profile/edit/ABM-onboarding/declarations"
          component={withLoading(Declarations)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding"
          component={withLoading(GateOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/application"
          component={withLoading(Application)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/work-history"
          component={withLoading(YearWorkHistory)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/reference-education"
          component={withLoading(ReferenceEducation)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/declaration"
          component={withLoading(Declaration)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding"
          component={withLoading(PusterlaOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding/assessment"
          component={withLoading(PusterlaAssessment)}
        />
        <Route
          exact
          path="/profile/edit/pusterla-onboarding/assessment/feedback"
          component={withLoading(AssessmentFeedback)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding"
          component={withLoading(SwissportOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/FiveYearHistory"
          component={withLoading(FiveYearHistory)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/EmployeeHealthQuestionnaire"
          component={withLoading(EmployeeHealthQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/PersonalInformationForm"
          component={withLoading(PersonalInformationForm)}
        />
        <Route
          exact
          path="/profile/edit/swissport-onboarding/InformationReleaseForm"
          component={withLoading(InformationReleaseForm)}
        />
        <Route
          exact
          path="/profile/edit/onboarding-pecan"
          component={withLoading(PecanOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/onboarding-pecan/nextOfKinForm"
          component={withLoading(NextOfKinForm)}
        />
        <Route
          exact
          path="/profile/edit/onboarding-pecan/healthQuestionnaireForm"
          component={withLoading(HealthQuestionnaireForm)}
        />
        <Route
          exact
          path="/profile/edit/onboarding-pecan/assessment"
          component={withLoading(PecanAssessment)}
        />
        <Route
          exact
          path="/profile/edit/carlton-forest-onboarding"
          component={withLoading(CarltonForestOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding"
          component={withLoading(ThanetCouncilOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/benefits-declaration"
          component={withLoading(BenefitsDeclarationForm)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/driver-declaration"
          component={withLoading(DriverDeclarationForm)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/induction-signoff"
          component={withLoading(InductionSignoffForm)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/questions-stage1"
          component={withLoading(QuestionsStage1Form)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/shift-induction"
          component={withLoading(ShiftInductionForm)}
        />
        <Route
          exact
          path="/profile/edit/thanet-council-onboarding/dvla-check-and-signature"
          component={withLoading(DVLACheckAndSignatureForm)}
        />
        <Route
          exact
          path="/profile/edit/cpi-onboarding"
          component={withLoading(CpiOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/carlton-forest-onboarding/induction"
          component={withLoading(InductionChecklist)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding"
          component={withLoading(GateOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding"
          component={withLoading(WoodlandGroupOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/site-rules"
          component={withLoading(SiteRules)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/policies"
          component={withLoading(Policies)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/hand-outs"
          component={withLoading(HandOuts)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/machinery"
          component={withLoading(Machinery)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/training"
          component={withLoading(Training)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/manual-handling"
          component={withLoading(ManualHandling)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/fire-safety"
          component={withLoading(FireSafety)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/incident-reporting"
          component={withLoading(IncidentReporting)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding"
          component={withLoading(WoodlandGroupOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/site-rules"
          component={withLoading(SiteRules)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/policies"
          component={withLoading(Policies)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/hand-outs"
          component={withLoading(HandOuts)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/machinery"
          component={withLoading(Machinery)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/training"
          component={withLoading(Training)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/manual-handling"
          component={withLoading(ManualHandling)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/fire-safety"
          component={withLoading(FireSafety)}
        />
        <Route
          exact
          path="/profile/edit/woodland-group-onboarding/incident-reporting"
          component={withLoading(IncidentReporting)}
        />
        <Route
          exact
          path="/profile/edit/compleat-food-onboarding"
          component={withLoading(CompleatFoodOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/grow-up-farms-onboarding"
          component={withLoading(GrowUpFarmsOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/grow-up-farms-onboarding/health-and-safety-questionnaire"
          component={withLoading(HealthAndSafetyQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/grow-up-farms-onboarding/food-and-safety-questionnaire"
          component={withLoading(FoodSafetyQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding"
          component={withLoading(DavinFoodsOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/food-safety-quiz"
          component={withLoading(FoodSafetyQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/food-allergens-quiz"
          component={withLoading(FoodAllergensQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/health-and-safety-quiz"
          component={withLoading(HealthAndSafetyQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/chemical-safety-quiz"
          component={withLoading(ChemicalSafetyQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/evacuation-quiz"
          component={withLoading(EvacuationQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/manual-handling-quiz"
          component={withLoading(ManualHandlingQuiz)}
        />
        <Route
          exact
          path="/profile/edit/davin-foods-onboarding/induction-checklist"
          component={withLoading(InductionChecklistDavinFoods)}
        />
        <Route
          exact
          path="/profile/edit/compleat-food-onboarding/new-starters-details"
          component={withLoading(NewStartersDetailsForm)}
        />
        <Route
          exact
          path="/profile/edit/compleat-food-onboarding/consent-for-health-screening"
          component={withLoading(ConsentForHealthScreeningForm)}
        />
        <Route
          exact
          path="/profile/edit/compleat-food-onboarding/personal-data-consent"
          component={withLoading(PersonalDataConsentForm)}
        />
        <Route
          exact
          path="/profile/edit/compleat-food-onboarding/medical-questionnaire"
          component={withLoading(MedicalQuestionnaireForm)}
        />
        <Route
          exact
          path="/profile/edit/molecular-onboarding"
          component={withLoading(MolecularOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/molecular-onboarding/consent-drug-alcohol"
          component={withLoading(ConsentDrugAlcoholForm)}
        />
        <Route
          exact
          path="/profile/edit/molecular-onboarding/literacy-assessment"
          component={withLoading(LiteracyAssessment)}
        />

        <Route
          exact
          path="/profile/edit/gate-group-onboarding/application"
          component={withLoading(Application)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/work-history"
          component={withLoading(YearWorkHistory)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/reference-education"
          component={withLoading(ReferenceEducation)}
        />
        <Route
          exact
          path="/profile/edit/gate-group-onboarding/declaration"
          component={withLoading(Declaration)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding"
          component={withLoading(DrivingOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/upload"
          component={withLoading(UploadContainer)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/upload"
          component={withLoading(UploadContainer)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/skills-and-qualifications"
          component={withLoading(SkillsAndQualificationsForm)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/licence-details-and-dvla-check"
          component={withLoading(LicenceDetailsAndDvlaCheck)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/compliance-and-drivers-declaration"
          component={withLoading(ComplianceAndDriversDeclaration)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/non-hgv-assessment"
          component={withLoading(NonHGVAssessment)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/driver-assessment"
          component={withLoading(DriverAssessment)}
        />
        <Route
          exact
          path="/profile/edit/driving-onboarding/assessment/feedback"
          render={({ location: { state } }) => {
            const FeedbackAuth = withLoading(FeedbackScreen);
            return <FeedbackAuth state={state} />;
          }}
        />
        <Route
          exact
          path="/profile/edit/gb-onboarding"
          component={withLoading(GreatBearOnboardingContainer)}
        />
        <Route
          exact
          path="/profile/edit/onboardingGB"
          component={withLoading(GreatBearOnboardingContainer)}
        />
        <Route
          exact
          path="/profile/edit/onboarding"
          component={withLoading(ReflexAllenOnboarding)}
        />
        <Route
          exact
          path="/profile/edit/onboarding/induction-programme"
          component={withLoading(InductionProgramme)}
        />
        <Route
          exact
          path="/profile/edit/onboarding/night-workers-questionnaire"
          component={withLoading(NightWorkersQuestionnaire)}
        />
        <Route
          exact
          path="/profile/edit/resources/night-worker-health-assessment"
          component={withLoading(NightWorkerHealthAssessment)}
        />

        <Route
          exact
          path="/profile/edit/resources/authority-for-payments-assessment"
          component={withLoading(AuthorityForPaymentsAssesment)}
        />
        <Route
          exact
          path="/profile/edit/onboarding/regulations"
          component={withLoading(RegulationsForm)}
        />

        <Route
          exact
          path="/profile/edit/Holiday"
          component={withLoading(Holiday)}
        />
        <Route
          exact
          path="/profile/edit/Payslips"
          component={withLoading(Payslips)}
        />
        <Route
          exact
          path="/profile/edit/Timesheets"
          component={withLoading(Timesheets)}
        />
        <Route
          exact
          path="/profile/edit/Shifts"
          component={withLoading(Shifts)}
        />
        <Route
          exact
          path="/profile/edit/Timesheets/:timesheetRef"
          component={({ match }) => (
            <Timesheet
              timesheetRef={Number.parseInt(match.params.timesheetRef, 10)}
            />
          )}
        />
        <Route
          exact
          path="/profile/edit/Timesheets/:timesheetRef/edit"
          component={({ match }) => (
            <Timesheet
              timesheetRef={Number.parseInt(match.params.timesheetRef, 10)}
              isEditing
            />
          )}
        />
        <Route
          path="/profile/edit/:id"
          render={() => (
            <ProfileLoading>
              <Route exact path="/profile/edit/bookings" component={Bookings} />
              <Route
                exact
                path="/profile/edit/bookings/:bookingRef"
                component={({ match }) => (
                  <HideBodyOverflowY>
                    <BookingDetails
                      match={match}
                      bookingRef={Number.parseInt(match.params.bookingRef, 10)}
                      isAll={match.params.bookingRef === "all"}
                    />
                  </HideBodyOverflowY>
                )}
              />
              <Route
                exact
                path="/profile/edit/bookings/:bookingRef/past"
                component={({ match }) => (
                  <HideBodyOverflowY>
                    <BookingDetails
                      isPast
                      bookingRef={Number.parseInt(match.params.bookingRef, 10)}
                    />
                  </HideBodyOverflowY>
                )}
              />
            </ProfileLoading>
          )}
        />
      </Switch>
    </ScrollToTop>
  </Fragment>
);

export default Routes;
